import { MatTooltipModule} from '@angular/material/tooltip';
import { CardMenuComponent } from './card-menu/card-menu.component';
import { SalesCardComponent } from './sales-card/sales-card.component';
import { ServiceCardComponent } from './service-card/service-card.component';
import { AppointmentSectionComponent } from './appointment-section/appointment-section.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { BDCDashboardComponent } from './bdc-dashboard.component';
import { BDCDashboardRoutingModule } from './bdc-dashboard-routing.module';


@NgModule({
    declarations: [
        BDCDashboardComponent,
        AppointmentSectionComponent,
        ServiceCardComponent,
        SalesCardComponent,
        CardMenuComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        MatTooltipModule,
        BDCDashboardRoutingModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BDCDashboardModule { }
